var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConicalFlask = function SvgConicalFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "conical-flask_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conical-flask_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.553 2c.69 0 1.25.56 1.25 1.25v13.319L8.663 38.826c-.26.538-.216 1.329.199 2.05.413.72 1.049 1.124 1.691 1.124h13a1.25 1.25 0 0 1 0 2.5h-13c-1.757 0-3.121-1.095-3.858-2.377-.73-1.27-.99-2.97-.26-4.432l.01-.02 11.858-21.74V3.25c0-.69.56-1.25 1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.553 2c-.69 0-1.25.56-1.25 1.25v13.319l12.14 22.257c.26.538.217 1.329-.198 2.05-.413.72-1.05 1.124-1.692 1.124h-13a1.25 1.25 0 1 0 0 2.5h13c1.758 0 3.122-1.095 3.859-2.377.73-1.27.99-2.97.26-4.432l-.01-.02-11.859-21.74V3.25c0-.69-.56-1.25-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.21 29.25c0-.69.559-1.25 1.25-1.25h22.187a1.25 1.25 0 1 1 0 2.5H12.46c-.69 0-1.25-.56-1.25-1.25ZM15.303 3.25c0-.69.56-1.25 1.25-1.25h14a1.25 1.25 0 1 1 0 2.5h-14c-.69 0-1.25-.56-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 29-22 .5-5.5 10 3.5 4H38l2-5-5.5-9.5Z"
  }))));
};
export default SvgConicalFlask;